var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wikiPage"},[_c('page-title',{attrs:{"showExport":""}},[_vm._v(_vm._s(_vm.$t('wiki.node')))]),_vm._v(" "),_c('active-info-page',{attrs:{"scope":{wikiPage: _vm.wikiPage},"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }